<template>
  <div class="tender-summary-wrapper">
    <div class="tender-info__container">
      <div v-if="isTenderOffers($route)" class="tender-info-block"><OfferActions /></div>
      <div
        id="tender-summary-content"
        class="tender-summary-content tender-summary-content_incoming spacey-12"
      >
        <div class="tender-summary-base-block">
          <router-view />
        </div>
      </div>
    </div>
    <div class="tender-summary-chat-block">
      <Chat />
    </div>
  </div>
</template>

<script>
  import Chat from '@/containers/chat/Chat';
  import OfferActions from '@/containers/tender/OfferActions';
  import { isTenderOffers } from '@/utils/route-matcher';

  export default {
    name: 'TenderSummary',
    components: {
      Chat,
      OfferActions,
    },
    methods: {
      isTenderOffers,
    },
  };
</script>
